import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

const invoicingPath = {
	path: "/billing/invoicing",
	component: lazy(() => import("./TripInvoicingPage")),
};

export default build([invoicingPath]);
